"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuoteSchema = void 0;
exports.QuoteSchema = {
    "$id": "https://www.redbull.com/schemas/attributes/quote.schema.json",
    "$schema": "https://json-schema.org/draft/2020-12/schema",
    "title": "Quote",
    "description": "Repeat words from a text or speech written or spoken by another person",
    "type": "object",
    "additionalProperties": false,
    "properties": {
        "type": {
            "type": "string",
            "enum": [
                "attributes:quote"
            ]
        },
        "author": {
            "oneOf": [
                {
                    "type": "object",
                    "$ref": "https://www.redbull.com/schemas/attributes/text.schema.json"
                },
                {
                    "type": "object",
                    "$ref": "https://www.redbull.com/schemas/reference/content/judges.schema.json"
                },
                {
                    "type": "object",
                    "$ref": "https://www.redbull.com/schemas/reference/content/person-profiles.schema.json"
                },
                {
                    "type": "object",
                    "$ref": "https://www.redbull.com/schemas/reference/content/photographers.schema.json"
                },
                {
                    "type": "object",
                    "$ref": "https://www.redbull.com/schemas/reference/content/rally-drivers.schema.json"
                }
            ]
        },
        "quoteText": {
            "$ref": "https://www.redbull.com/schemas/attributes/textual-artefact-container.schema.json"
        }
    },
    "required": [
        "quoteText",
        "type"
    ]
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicXVvdGUuc2NoZW1hLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL21vZHVsZXMvYXR0cmlidXRlcy9xdW90ZS5zY2hlbWEudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQWEsUUFBQSxXQUFXLEdBQUc7SUFDekIsS0FBSyxFQUFFLDhEQUE4RDtJQUNyRSxTQUFTLEVBQUUsOENBQThDO0lBQ3pELE9BQU8sRUFBRSxPQUFPO0lBQ2hCLGFBQWEsRUFBRSx3RUFBd0U7SUFDdkYsTUFBTSxFQUFFLFFBQVE7SUFDaEIsc0JBQXNCLEVBQUUsS0FBSztJQUM3QixZQUFZLEVBQUU7UUFDWixNQUFNLEVBQUU7WUFDTixNQUFNLEVBQUUsUUFBUTtZQUNoQixNQUFNLEVBQUU7Z0JBQ04sa0JBQWtCO2FBQ25CO1NBQ0Y7UUFDRCxRQUFRLEVBQUU7WUFDUixPQUFPLEVBQUU7Z0JBQ1A7b0JBQ0UsTUFBTSxFQUFFLFFBQVE7b0JBQ2hCLE1BQU0sRUFBRSw2REFBNkQ7aUJBQ3RFO2dCQUNEO29CQUNFLE1BQU0sRUFBRSxRQUFRO29CQUNoQixNQUFNLEVBQUUsc0VBQXNFO2lCQUMvRTtnQkFDRDtvQkFDRSxNQUFNLEVBQUUsUUFBUTtvQkFDaEIsTUFBTSxFQUFFLCtFQUErRTtpQkFDeEY7Z0JBQ0Q7b0JBQ0UsTUFBTSxFQUFFLFFBQVE7b0JBQ2hCLE1BQU0sRUFBRSw2RUFBNkU7aUJBQ3RGO2dCQUNEO29CQUNFLE1BQU0sRUFBRSxRQUFRO29CQUNoQixNQUFNLEVBQUUsNkVBQTZFO2lCQUN0RjthQUNGO1NBQ0Y7UUFDRCxXQUFXLEVBQUU7WUFDWCxNQUFNLEVBQUUsbUZBQW1GO1NBQzVGO0tBQ0Y7SUFDRCxVQUFVLEVBQUU7UUFDVixXQUFXO1FBQ1gsTUFBTTtLQUNQO0NBQ0YsQ0FBQSJ9